import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobal } from 'reactn';
import { Form } from 'react-bootstrap';
import Selectivity from 'selectivity/react';

const AddressBlock = (props) => {

  const { t } = useTranslation(['addressblock']);
  const [masterData] = useGlobal('masterData');
  const { addressTitle, address, setAddress, errors, setErrors } = props;

  const prefix = addressTitle.startsWith('billing') ? 'Bill_' : 'Post_';

  console.log(prefix);

  const updateField = e => {
    let field = e.target.name;
    setAddress({
      ...address,
      [field]: e.target.value
    });

    if (!!errors[prefix + field]) setErrors({
      ...errors,
      [prefix + field]: null
    });
  }

  const onChangeCountry = (e) => {
    setAddress({ ...address, refCountryId: e.value });
    if (!!errors[prefix + 'refCountryId']) setErrors({
      ...errors,
      [prefix + 'refCountryId']: null
    });
  };

  return (
    <>
      <div className="column-8 offset-2">
        <h4>{t(addressTitle)}</h4>
      </div>

      <div className="column-8 offset-2">
        <div className="form-group">
          <label className="form-label">
            {t("street")}
          </label>
          <input className="form-control" type="text" name="Street" value={address.Street} onChange={updateField} />
          <Form.Control.Feedback type='invalid'>
            {errors[prefix + 'Street']}
          </Form.Control.Feedback>
        </div>

        <div className="form-group">
          <label className="form-label">
            {t("street2")}
          </label>
          <input className="form-control" type="text" name="AddressAddition" value={address.AddressAddition} onChange={updateField} />
        </div>

        <div className="form-group">
          <label className="form-label">
            {t("postalCode")}
          </label>
          <input className="form-control" type="text" name="PostalCode" value={address.PostalCode} onChange={updateField} />
          <Form.Control.Feedback type='invalid'>
            {errors[prefix + 'PostalCode']}
          </Form.Control.Feedback>
        </div>

        <div className="form-group">
          <label className="form-label">
            {t("city")}
          </label>
          <input className="form-control" type="text" name="City" value={address.City} onChange={updateField} />
          <Form.Control.Feedback type='invalid'>
            {errors[prefix + 'City']}
          </Form.Control.Feedback>
        </div>

        <div className="form-group">
          <label className="form-label">
            {t("country")}
          </label>
          <div className="form-control form-select">
            <Selectivity.React
              multiple={false}
              items={masterData.countries}
              placeholder={t("country")}
              className="sr-wrapper"
              value={address.refCountryId}
              onChange={onChangeCountry}
            />
          </div>
          <Form.Control.Feedback type='invalid'>
            {errors[prefix + 'refCountryId']}
          </Form.Control.Feedback>
        </div>

      </div>
    </>
  );
}

export default AddressBlock;